module.exports = __webpack_public_path__ + "img/black.67f9808a.png";